import { Check } from 'lucide-react';
import { cn } from '@reflex/ui/lib/utils';
import type { ThemeDefinition } from './themes';

interface ThemePickerProps {
  themes: ThemeDefinition[];
  value: string;
  onChange: (themeId: string) => void;
  className?: string;
}

export function ThemePicker({ themes, value, onChange, className }: ThemePickerProps) {
  return (
    <div className={cn('grid grid-cols-3 gap-3 sm:grid-cols-4 md:grid-cols-5', className)}>
      {themes.map((theme) => {
        const isSelected = theme.id === value;
        const darkPrimary = theme.cssVars.dark['--primary'];
        const darkBg = theme.cssVars.dark['--background'];
        const darkMuted = theme.cssVars.dark['--muted'];

        return (
          <button
            key={theme.id}
            type="button"
            onClick={() => onChange(theme.id)}
            className={cn(
              'group relative flex flex-col items-center gap-2 rounded-lg border p-3 transition-colors',
              isSelected
                ? 'border-primary bg-primary/5 ring-2 ring-primary/20'
                : 'border-border hover:border-muted-foreground/30 hover:bg-muted/50',
            )}
          >
            {/* Color swatch preview showing dark theme colors */}
            <div
              className="flex h-10 w-full overflow-hidden rounded-md"
              style={{ backgroundColor: darkBg }}
            >
              <div className="flex-1" />
              <div className="w-6" style={{ backgroundColor: darkMuted }} />
              <div className="w-4" style={{ backgroundColor: darkPrimary }} />
            </div>

            <span className="text-xs font-medium">{theme.label}</span>

            {isSelected && (
              <div className="absolute right-1.5 top-1.5 flex h-4 w-4 items-center justify-center rounded-full bg-primary text-primary-foreground">
                <Check className="h-3 w-3" />
              </div>
            )}
          </button>
        );
      })}
    </div>
  );
}
